/**
 * Hosted stage Docker builds often set APP_ENV=production. Detect the
 * real environment from APP_URL for logging and non-licence behaviour.
 */
const NON_PROD_HOST_MARKERS = ["localhost", "127.0.0.1", ".stage.", "-stage.", ".dev."];

export function isNonProductionHost(
  appUrl: string = process.env.APP_URL ?? "",
  appEnv: string = process.env.APP_ENV ?? ""
): boolean {
  const url = appUrl.toLowerCase();
  if (NON_PROD_HOST_MARKERS.some((marker) => url.includes(marker))) return true;
  return appEnv !== "" && appEnv !== "production";
}

export interface WordLicenseFields {
  is_ms_word_license?: boolean;
  isMsWordLicense?: boolean;
}

/**
 * Licence is required in every environment, including stage and production.
 * A user is allowed only when the subscription explicitly grants the Word
 * add-in licence. Missing/undefined is treated as unlicensed.
 *
 * Read both snake_case (API) and camelCase so a licensed user is not frozen
 * if a transform renames the field.
 */
export function hasWordAddinLicense(subscription: WordLicenseFields | undefined): boolean {
  if (subscription == null) return false;
  return subscription.is_ms_word_license === true || subscription.isMsWordLicense === true;
}

export function isWordLicenseBlocked(subscription: WordLicenseFields | undefined): boolean {
  return !hasWordAddinLicense(subscription);
}
